const PaymentGateways = {
  MERCADO_PAGO: 'mercado_pago',
  PAYPAL: 'paypal',
  ESSEN: 'essen',
  FENICIO: 'fenicio',
  JUMBO: 'jumbo',
  CASH: 'cash',
  VTEX: 'vtex',
  MAGENTO2: 'magento2',
  TIENDA_NUBE: 'tienda_nube',
  ESSEN_ECOMMERCE: 'essen_ecommerce',
  PLAZAH: 'plazaH',
  CENCOSUD_PARIS: 'cencosud_paris',
  SHOPIFY: 'shopify',
  CARSO: 'carso',
  TO_AGREE: 'to_agree',
  STRIPE: 'stripe',
  PRIVALIA_HOME: 'privalia_home',
  LINX: 'linx',
  LIGHT: 'light',
  NATURA: 'natura',
  KIEHLS: 'kiehls',
  LANCOME: 'lancome',
  WALMART: 'walmart',
}

export default PaymentGateways
